import { z } from "zod";
export const wreathTagSchema = z.enum([
    "Grapevine",
    "Evergreen",
    "Holiday",
    "Autumn",
    "Spring",
    "Eucalyptus",
    "Funeral",
]);
export const legalWreathTags = wreathTagSchema.options;
export const wreathDiameterSchema = z.enum([
    "6 - 10 in.",
    "12 - 16 in.",
    "18 - 22 in.",
    "24 - 28 in.",
    "30 - 34 in.",
]);
export const legalWreathDiameters = wreathDiameterSchema.options;
//# sourceMappingURL=wreaths.js.map